import { Suspense, useEffect, useState } from "react";
import {
  TableFilters,
  TableFiltersState,
} from "../../../../common/components/ui/table/TableFilters";
import Loading from "../../../../common/components/ui/loading/Loading";
import GenericTable from "../../../../common/components/ui/table/GenericTable";
import TableFooter from "../../../../common/components/ui/table/TableFooter";
import ModalCreatePurchaseRequestor from "../modals/ModalCreatePurchaseRequestor";
import { getPurchaseRequestors } from "../../../../common/services/purchaseRequestor.api";
import { IPurchaseRequestor } from "../../../../types/purchaseRequestor.type";
import { useCompanyStore } from "../../../../common/states/store/Company";
import { getCompanyId } from "../../../../common/services/company.api";

function TablePurchaseRequestor() {
  const company = useCompanyStore();
  const companyId = getCompanyId();
  const [page, setPage] = useState<number>(1);
  const [data, setData] = useState({ itemsPerPage: 10, totalItems: 0 });
  const [purchaseRequestor, setPurchaseRequestor] = useState<
    IPurchaseRequestor[]
  >([]);
  const [filters, setFilters] = useState<TableFiltersState>({
    search: "",
    status: [],
  });
  const EMPTY_ACTION = { eventName: "", data: undefined };
  const [action, setAction] = useState<{ eventName: string; data?: unknown }>(
    EMPTY_ACTION
  );

  const [isLoading, setIsLoading] = useState(false);
  const isAction = (eventName: string) => action.eventName === eventName;

  const cleanActionData = () => {
    handleSearch(filters);
    setAction(EMPTY_ACTION);
  };

  const handleSearch = ({ search, status }) => {
    const newState = Object.assign({}, filters, { search, status });
    setFilters(newState);
  };

  useEffect(() => {
    async function loadPurchaseRequestor() {
      setIsLoading(true);
      const result = await getPurchaseRequestors({ ...filters, page });
      setData({
        itemsPerPage: data.itemsPerPage,
        totalItems: result.totalItems,
      });
      setPurchaseRequestor(result.data);
      setIsLoading(false);
    }
    loadPurchaseRequestor();
  }, [data.itemsPerPage, filters, page, companyId, company]);
  const handleFilterChange = (newFilters: Partial<TableFiltersState>) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      ...newFilters,
    }));
  };
  return (
    <Suspense fallback={<Loading />}>
      <div className="table-section">
        <TableFilters
          dashboardHeader="Solicitantes"
          placeholder="Digite o nome do solicitante."
          statusOptions={{}}
          tableData={purchaseRequestor}
          newItemLabel="Novo Solicitante"
          onNewItemClick={() =>
            setAction({ eventName: "create", data: undefined })
          }
          onSearch={handleFilterChange}
          entity="inventory-pieces"
        />
        <GenericTable
          headers={{
            name: "Nome",
          }}
          data={purchaseRequestor}
        />

        {isLoading && <Loading />}

        <TableFooter
          page={page || 1}
          totalItems={data.totalItems || 0}
          itemsPerPage={data.itemsPerPage || 10}
          goToPage={setPage}
        />
      </div>
      {isAction("create") && (
        <ModalCreatePurchaseRequestor onClose={cleanActionData} />
      )}
    </Suspense>
  );
}

export default TablePurchaseRequestor;
